var safeJsonParse=function(jsonString){try{return JSON.parse(jsonString)}catch(e){return}};export{safeJsonParse};
//# sourceMappingURL=jsonUtils.js.map
